import CustomToaster from '@/components/toast/CustomToaster.vue';
export function createToastContent(title, message) {
    return {
        component: CustomToaster,
        props: { title, message },
    };
}
